var r = /* @__PURE__ */ ((n) => (n.Success = "success", n.Warning = "warning", n.Danger = "danger", n.Info = "info", n.Positive = "positive", n.Negative = "negative", n.BackgroundAlt = "background-alt", n.BackgroundDefault = "background-default", n))(r || {});
const t = [
  "success",
  "warning",
  "danger",
  "info",
  "positive",
  "negative",
  "background-alt",
  "background-default"
];
export {
  t as BADGE_MODES,
  r as BadgeMode
};
